module.exports = __webpack_public_path__ + "static/media/object-icon.9d80bf40.svg";